export default __webpack_public_path__ + "static/media/D8.eb5bd0dd.png";